import { useMemo } from 'react';
import {
  AppointmentTypeGroup,
  BookableAppointmentType,
} from '@weave/schema-gen-ts/dist/schemas/schedule/v3/bookable_appointment_type.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';

export type BookableAppointmentTypeOption = {
  id: string;
  appointmentTypeId?: string;
  name?: string;
  durationMinutes?: number;
  color?: string;
};

export const useBookableAppointmentTypes = (locationId: string) => {
  const query = SchedulerV3.Queries.useListGroupedBookableAppointmentTypesQuery({
    request: { locationId },
    options: { enabled: !!locationId },
  });

  const bookableAppointmentTypes = useMemo<BookableAppointmentTypeOption[]>(
    () =>
      ((query.data?.appointmentTypeGroups ?? []) as AppointmentTypeGroup[]).flatMap((group) =>
        (group.bookableAppointmentTypes ?? []).map(
          (bookable: BookableAppointmentType) =>
            ({
              id: bookable.id,
              appointmentTypeId: bookable.appointmentTypeId,
              name: bookable.displayName,
              durationMinutes: bookable.duration,
              color: group.appointmentType.details?.clr ?? undefined,
            } satisfies BookableAppointmentTypeOption)
        )
      ),
    [query.data?.appointmentTypeGroups]
  );

  return { bookableAppointmentTypes, query };
};
